import * as z from "zod";

import { partnerIdSchema } from "./shared";

export const revokePartnerApiToken = {
  name: "revokePartnerApiToken" as const,
  input: z.object({ partnerId: partnerIdSchema, tokenId: partnerIdSchema }),
  output: z.object({}),
};
